import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[searchFieldHost]',
})
export class SearchFieldDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
